import { urlFor } from "../../data/sanity/client";

// logoDark is the artwork for light backgrounds and vice versa. Only one is
// required, so each mode falls back to whichever exists.
function LogoBubble({ client, darkMode }) {
  const source = darkMode
    ? client?.logoLight || client?.logoDark
    : client?.logoDark || client?.logoLight;

  if (!source) return null;

  return (
    <img
      src={urlFor(source).height(120).url()}
      alt=""
      className="h-[36px] sm:h-[60px] w-auto flex-shrink-0"
      draggable={false}
    />
  );
}

export default LogoBubble;
